import React from 'react';
import { Route, withRouter } from 'react-router';
import DownloadDataForm from "./components/downloadDataForm";


const DownloadData = () => {
    return (
        <>
            <Route path="/downloaddata" component={withRouter(DownloadDataForm)} />
        </>
    )
};

export default DownloadData;

